document.addEventListener('DOMContentLoaded', function () {
  const PR = window.PRPurchase;
  const productForm = document.querySelector('.product-single__form');
  if (!productForm || !PR) return;
  const root = productForm.closest('[data-pr-pdp]');
  if (!root || root.dataset.prFlavor !== 'mist') return;

  const FREE_SHIPPING_THRESHOLD_CENTS = PR.FREE_SHIPPING_THRESHOLD_CENTS;
  const productData = PR.readProduct(productForm);
  const plans = PR.readPlans();
  const productContainer = root.querySelector('.custom-subscription-widget-container');
  if (!productContainer || !productData) return;

  const subscriptionIdInput = productForm.querySelector('input[name="selling_plan"]');
  const variantIdInput = productForm.querySelector('[name="id"]');
  const btnTextElement = productForm.querySelector('.btn--add-to-cart .btn__text');
  const shippingPriceElement = productContainer.querySelector('#buy-once-option .shipping-price');
  const packButtons = productContainer.querySelectorAll('.pack-button');

  const looksLikePack = function (opt) {
    return opt != null && /^\s*\d+\s*(-?\s*pack)?\s*$/i.test(String(opt));
  };

  const option1 = productForm.querySelectorAll('input[name="option1"]');
  const option2 = productForm.querySelectorAll('input[name="option2"]');
  let measureRadios = [];
  if (option1.length && !looksLikePack(option1[0].value)) measureRadios = option1;
  else if (option2.length && !looksLikePack(option2[0].value)) measureRadios = option2;

  let selectedMeasure = '';
  let selectedBuyOncePack = '1-Pack';

  const getVariant = function (measure, pack) {
    return (
      productData.variants.find(function (v) {
        return (v.option1 === measure || v.option2 === measure) && (v.option1 === pack || v.option2 === pack);
      }) ||
      productData.variants.find(function (v) {
        return v.option1 === pack || v.option2 === pack;
      })
    );
  };

  const unitPrice = function () {
    const one = getVariant(selectedMeasure, '1-Pack');
    return one && one.price > 0 ? one.price : 3500;
  };

  const formulaBase = function (pack) {
    return PR.parsePack(pack) * unitPrice();
  };

  const bottlesLabel = function (n) {
    if (selectedMeasure === '4 Fills 8oz') return n === 1 ? '4 fills' : n + ' x 4 fills';
    if (selectedMeasure === 'Rose Mist Set 10oz') return n === 1 ? 'set' : n + ' sets';
    return n === 1 ? '1 bottle' : n + ' bottles';
  };

  // Ported from the Brooklyn theme's mist-plan-map. Rose Mist carries six generic
  // percentage "Subscribe & Save" groups that sort ahead of its product-specific
  // fixed-price plans, so kind alone picks the wrong one; and each measure has its
  // own cadence -- 2oz bills monthly, the other two every two months. There is one
  // subscription card (see single_subscription_card in pr-rtx-mist.liquid) whose
  // heading and interval follow the measure.
  // This page now sells one thing: the Rose Mist Set on subscription. The 2oz is
  // a buy-once link under the button and 4 Fills 8oz is not offered here, so the
  // measure is pinned rather than driven by a picker.
  const SET_MEASURE = 'Rose Mist Set 10oz';
  // The Set is an 8oz refill plus a 2oz bottle -- five 2oz units.
  const UNITS_PER_SET = 5;
  // What the Set is compared against: $140 a shipment, so the $70 charged reads
  // as half price -- $70 struck against $35 on the per-month headline, and a
  // flat 50% on the pill. Stated rather than derived: pricing the baseline off
  // five standalone 2oz bottles ($175) put the card at 60% off a figure the
  // offer is not written around.
  const SET_COMPARE_PER_SHIPMENT = 14000;

  // `months` is what the headline price is divided by. The Set ships on an
  // 8-week plan ($70 a shipment), but it renders through the shared monthly
  // card, whose data-count-multiplier is 1 -- so the card read "$70 /mo"
  // directly above a meta row saying "$70 every 8 weeks".
  //
  // Held at 2 through the move from a 2-month plan to an 8-week one: 8 weeks is
  // 56 days rather than ~61, so the true figure is nearer $38, but the card is
  // written around the $35 headline and dividing by 1.84 would restate the
  // offer. Revisit with the pricing owner, not here.
  const MEASURE_MAP = {
    'Rose Mist Set 10oz': { planId: 7298744539, heading: '60-Day Supply', interval: 'every 8 weeks', months: 2 },
  };

  const measureConfig = function () {
    return MEASURE_MAP[selectedMeasure] || null;
  };

  const updateFirstCardCopy = function () {
    const cfg = measureConfig();
    if (!cfg) return;
    const headingEl = productContainer.querySelector('.js-first-card-heading');
    if (headingEl) headingEl.textContent = cfg.heading;
    // cfg.interval reaches the card through the billing row's label only
    // (updateSetFigures below); the check-list line stopped restating the
    // cadence on 14 Sep 2026, so there is no .js-first-card-interval to fill.
  };

  // The collapsed "Buy Once for ..." link advertises the Set bought
  // outright. Server-side it renders from current_variant, which on this product
  // is the 2oz ($35) -- the wrong figure, since Buy Once sells the Set.
  const updateBuyOnceTrigger = function () {
    const priceEl = productContainer.querySelector('.js-buy-once-price');
    const shipEl = productContainer.querySelector('.js-buy-once-shipping');
    if (!priceEl && !shipEl && !shippingPriceElement) return;
    const once = getTargetData(false, selectedBuyOncePack, 'onetime');
    if (!once.variant) return;
    if (priceEl) priceEl.textContent = PR.formatMoney(once.price);
    const free = once.price >= FREE_SHIPPING_THRESHOLD_CENTS;
    // The collapsed link supplies its own "+" in the markup; the card's line
    // stands alone under the price, so it carries the "+" itself.
    if (shipEl) shipEl.textContent = free ? 'Free Shipping' : PR.DEFAULT_SHIPPING_TEXT;
    // Priced from the one-time allocation so the card reads correctly even
    // while a subscription is the selected option.
    if (shippingPriceElement) {
      shippingPriceElement.textContent = free ? 'Free Shipping' : '+ ' + PR.DEFAULT_SHIPPING_TEXT;
    }
  };

  // Billing amount + cadence on the left, price per 2oz on the right, plus the
  // saving that drives both the pill and the button.
  const updateSetFigures = function (subPrice) {
    const cfg = measureConfig();
    if (!cfg || !subPrice) return;

    const totalEl = productContainer.querySelector('.js-first-total');
    if (totalEl) totalEl.textContent = PR.formatMoney(subPrice);
    const labelEl = productContainer.querySelector('.js-first-total-label');
    if (labelEl) labelEl.textContent = cfg.interval;

    const perUnitEl = productContainer.querySelector('.js-first-per-unit');
    if (perUnitEl) perUnitEl.textContent = PR.formatMoney2(subPrice / UNITS_PER_SET) + ' / 2oz';

    const standalone = SET_COMPARE_PER_SHIPMENT;
    let pct = 0;
    if (standalone > subPrice) pct = Math.round(((standalone - subPrice) / standalone) * 100);

    const pill = productContainer.querySelector('.purchase-option-label .savings-label');
    if (pill) {
      pill.textContent = pct > 0 ? 'Save ' + pct + '%' : '';
      pill.style.display = pct > 0 ? 'inline-block' : 'none';
      // This badge is written here rather than by fillPriceDetails -- the Set is
      // compared against a stated per-shipment figure, not the pack formula --
      // so carry the same number onto the label the CTA reads. Without this the
      // button advertised the flat 20% while the badge beside it said 50%.
      const ownLabel = pill.closest('.purchase-option-label');
      if (ownLabel) {
        if (pct > 0) ownLabel.dataset.prSavePct = String(pct);
        else delete ownLabel.dataset.prSavePct;
      }
    }
    return pct;
  };

  const getTargetData = function (isSubscription, pack, kind, planId) {
    const variant = getVariant(selectedMeasure, pack);
    if (!variant) return { variant: null, price: 0, sellingPlan: '' };
    const record = PR.variantRecord(plans, variant.id);
    if (isSubscription) {
      const alloc = PR.allocation(record, kind, planId);
      if (alloc && alloc.price > 0) {
        return { variant: variant, price: alloc.price, sellingPlan: alloc.plan_id };
      }
    }
    return { variant: variant, price: variant.price, sellingPlan: '' };
  };

  const updateLabels = function () {
    const monthlyEl = productContainer.querySelector('.js-monthly-qty');
    if (monthlyEl) monthlyEl.textContent = bottlesLabel(1);
    const threeEl = productContainer.querySelector('.js-three-month-qty');
    if (threeEl) threeEl.textContent = bottlesLabel(3);
    const sixEl = productContainer.querySelector('.js-six-month-qty');
    if (sixEl) sixEl.textContent = bottlesLabel(6);
    const onceEl = productContainer.querySelector('.js-buy-once-count');
    if (onceEl) onceEl.textContent = bottlesLabel(PR.parsePack(selectedBuyOncePack) || 1);
  };

  const updateFormAndPrices = function () {
    const selectedRadio = productContainer.querySelector('input[name="purchase_option"]:checked');
    if (!selectedRadio) return;
    const kind = selectedRadio.dataset.planKind || 'onetime';
    const isSubscription = kind !== 'onetime';
    const mult = parseInt(selectedRadio.dataset.countMultiplier, 10) || 1;
    const pack = isSubscription ? PR.packLabel(mult) : selectedBuyOncePack;
    const cfg = measureConfig();
    const data = getTargetData(isSubscription, pack, kind, isSubscription && cfg ? cfg.planId : null);
    if (!data.variant) return;

    if (variantIdInput) {
      variantIdInput.value = data.variant.id;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (subscriptionIdInput) subscriptionIdInput.value = data.sellingPlan || '';

    const buyOnceLabel = productContainer.querySelector('#buy-once-option');
    if (buyOnceLabel) {
      const once = getTargetData(false, selectedBuyOncePack, 'onetime');
      if (once.variant) PR.fillPriceDetails(buyOnceLabel, once.price, formulaBase(selectedBuyOncePack), 1, true);
    }

    productContainer.querySelectorAll('.purchase-option-label:not(.purchase-option-onetime)').forEach(function (label) {
      const radio = label.querySelector('input[name="purchase_option"]');
      if (!radio) return;
      const k = radio.dataset.planKind;
      const m = parseInt(radio.dataset.countMultiplier, 10) || 1;
      const vd = getTargetData(true, PR.packLabel(m), k, cfg ? cfg.planId : null);
      if (vd.variant) {
        // Divide by the cadence, not the pack multiplier: one shipment of the
        // Set covers 2 months. Both figures passed in describe that shipment, so
        // the struck-through base is divided by the same number.
        const months = (cfg && cfg.months) || m;
        PR.fillPriceDetails(label, vd.price, SET_COMPARE_PER_SHIPMENT * m, months, false);
        radio.dataset.sellingPlanId = vd.sellingPlan || '';
      }
    });

    updateLabels();
    updateFirstCardCopy();
    updateBuyOnceTrigger();
    productContainer.querySelectorAll('.pack-save-badge[data-pack-save-badge]').forEach(function (badge) {
      const packVal = badge.dataset.packSaveBadge;
      const variant = getVariant(selectedMeasure, packVal);
      if (!variant) {
        badge.textContent = '';
        return;
      }
      const base = formulaBase(packVal);
      badge.textContent = base > variant.price ? 'Save ' + Math.round(((base - variant.price) / base) * 100) + '%' : '';
    });

    // The card always describes the subscription, so price it from the
    // subscription allocation rather than from whatever option is selected --
    // passing 0 while Buy Once was active starved the per-2oz and the saving,
    // and the pill fell back to a generic figure.
    const cfgNow = measureConfig();
    const subData = getTargetData(true, PR.packLabel(1), 'monthly', cfgNow ? cfgNow.planId : null);
    updateSetFigures(subData.variant ? subData.price : 0);

    // The CTA sells the subscription: it restates the saving on the selected
    // card, and falls back to a plain Add to Cart for Buy Once.
    if (btnTextElement) {
      btnTextElement.textContent = PR.ctaText(productContainer, data.variant.available);
    }
  };

  // No measure listener: the offer picker is gone and only the hidden option
  // inputs remain, whose `checked` value would otherwise flip selectedMeasure
  // away from the Set.

  packButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      packButtons.forEach(function (b) {
        b.classList.remove('is-selected-pack');
      });
      button.classList.add('is-selected-pack');
      selectedBuyOncePack = button.dataset.packValue;
      const current = productContainer.querySelector('input[name="purchase_option"]:checked');
      if (current && current.value === 'onetime') updateFormAndPrices();
    });
  });

  PR.bindBuyOncePackReset(productContainer, function (pack) {
    selectedBuyOncePack = pack;
    updateFormAndPrices();
  });

  productContainer.querySelectorAll('input[name="purchase_option"]').forEach(function (radio) {
    radio.addEventListener('change', updateFormAndPrices);
  });

  selectedMeasure = SET_MEASURE;

  // Buy Once sells a single pack of the Set outright, so the link adds it to the
  // cart rather than opening a card the shopper then has to confirm with a
  // second click on Add to Cart. Sent direct, the way the "Try 2oz" link on this
  // page already does, so the form and whichever subscription card is selected
  // are both left exactly where they were.
  const BUY_ONCE_PACK = '1-Pack';
  let buyOnceBusy = false;
  const addBuyOnceToCart = function (toggle) {
    if (buyOnceBusy) return;
    const once = getTargetData(false, BUY_ONCE_PACK, 'onetime');
    if (!once.variant) return;
    buyOnceBusy = true;
    if (toggle) toggle.style.pointerEvents = 'none';
    const done = function () {
      buyOnceBusy = false;
      if (toggle) toggle.style.pointerEvents = '';
    };
    PR.addToCart(once.variant.id, 1).then(done, function () {
      done();
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      window.location.href = cartUrl + '/' + once.variant.id + ':1';
    });
  };

  PR.bindSelection(productContainer, { onBuyOnceClick: addBuyOnceToCart });
  PR.bindBanner(root);
  PR.bindVideos(root);
  updateFormAndPrices();
});
